import React from 'react';
import { motion } from 'framer-motion';
const services = [{
  title: 'Product Leadership',
  description: 'Strategic guidance for product teams to align vision with execution and deliver meaningful outcomes.',
  icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="w-8 h-8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-271">
        <path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-272" />
      </svg>
}, {
  title: 'Advisory',
  description: 'Expert consultation on product strategy, team structure, and process optimization for sustainable growth.',
  icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="w-8 h-8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-273">
        <path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" data-id="element-274" />
      </svg>
}, {
  title: 'Fractional CPO',
  description: 'Part-time product leadership to drive strategy and execution for companies not ready for a full-time CPO.',
  icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="w-8 h-8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-275">
        <path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" data-id="element-276" />
      </svg>
}, {
  title: 'Audits',
  description: 'Comprehensive assessment of product practices, user experience, and technical implementation to identify opportunities.',
  icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="w-8 h-8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-277">
        <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" data-id="element-278" />
      </svg>
}];
export function Services() {
  return <section id="services" className="py-28 px-6 md:px-12 relative overflow-hidden" style={{
    backgroundColor: '#F4F6ED'
  }} data-id="element-279">
      {/* Decorative elements */}
      <div className="absolute top-40 right-10 w-40 h-40 border border-ink-200 rounded-full opacity-30" data-id="element-280"></div>
      <div className="absolute bottom-40 left-10 w-24 h-24 border border-dashed border-ink-200 rounded-full opacity-30" data-id="element-281"></div>
      <div className="container mx-auto max-w-5xl" data-id="element-282">
        <motion.div className="mb-20" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-283">
          <div className="relative inline-block" data-id="element-284">
            <h2 className="text-3xl font-currency italic tracking-wide mb-5" data-id="element-285">
              Services
            </h2>
            <div className="absolute -right-8 top-1/2 transform -translate-y-1/2 w-6 h-px bg-ink-900" data-id="element-286"></div>
            <div className="absolute -left-8 top-1/2 transform -translate-y-1/2 w-6 h-px bg-ink-900" data-id="element-287"></div>
          </div>
          <div className="h-px w-16 bg-ink-900 mb-10" data-id="element-288"></div>
          <p className="text-ink-600 max-w-2xl font-serif" data-id="element-289">
            Specialized expertise to help your product team navigate complexity
            and deliver exceptional results.
          </p>
        </motion.div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10" data-id="element-290">
          {services.map((service, index) => <motion.div key={index} className="bg-white border border-ink-100 p-8 relative" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-291">
              {/* Added decorative corner lines */}
              <div className="absolute top-0 left-0 w-4 h-4 border-t border-l border-ink-200" data-id="element-292"></div>
              <div className="absolute top-0 right-0 w-4 h-4 border-t border-r border-ink-200" data-id="element-293"></div>
              <div className="absolute bottom-0 left-0 w-4 h-4 border-b border-l border-ink-200" data-id="element-294"></div>
              <div className="absolute bottom-0 right-0 w-4 h-4 border-b border-r border-ink-200" data-id="element-295"></div>
              <div className="text-ink-900 mb-5" data-id="element-296">{service.icon}</div>
              <h3 className="text-xl font-currency tracking-wide mb-4" data-id="element-297">
                {service.title}
              </h3>
              <p className="text-ink-600 font-serif" data-id="element-298">{service.description}</p>
            </motion.div>)}
        </div>
      </div>
      <div className="max-w-4xl mx-auto mt-32 px-6" data-id="element-299">
        <div className="h-px bg-ink-200 w-full" data-id="element-300"></div>
      </div>
    </section>;
}